import api from "./api";

const TimesheetService = {
    getSegments: (isoweek) =>
        api.get("/api/worksegments/", { params: { isoweek } }),

    getWeeklySummary: (isoweek) =>
        api.get("/api/worksegments/weekly-summary/", { params: { isoweek } }),

    createSegment: (data) => api.post("/api/worksegments/", data),
    updateSegment: (id, data) => api.patch(`/api/worksegments/${id}/`, data),
    deleteSegment: (id) => api.delete(`/api/worksegments/${id}/`),

    getWorkTypes: () => api.get("/api/worksegments/work-types/"),

    getPTO: (isoweek) =>
        api.get("/api/worksegments/pto/", { params: { isoweek } }),
    createPTO: (data) => api.post("/api/worksegments/pto/", data),
    updatePTO: (id, data) => api.patch(`/api/worksegments/pto/${id}/`, data),
    deletePTO: (id) => api.delete(`/api/worksegments/pto/${id}/`),

    searchProjects: (search) =>
        api.get("/api/projects/", { params: { search, is_archived: false } }),
};

export default TimesheetService;
